import React from "react";
import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="bg-[#0A2A20] text-slate-300 mt-20">
      <div className="px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto py-14 grid grid-cols-2 md:grid-cols-5 gap-8">
        <div className="col-span-2 md:col-span-1">
          <img src="/logo.png" alt="Dotlands Realty" className="h-24 w-auto mb-3 rounded-lg" />
          <p className="text-sm text-slate-400 leading-relaxed">Buy & sell verified agricultural land, plots and homes across India — direct deals with owners.</p>
          <p className="text-[#C8A24C] text-sm font-semibold mt-3 italic">Building Dreams. Creating Value.</p>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-3">Explore</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/agricultural-land" className="hover:text-emerald-400">Agricultural Land</Link></li>
            <li><Link to="/plots" className="hover:text-emerald-400">Plots & Layouts</Link></li>
            <li><Link to="/homes" className="hover:text-emerald-400">Homes & Houses</Link></li>
            <li><Link to="/commercial" className="hover:text-emerald-400">Commercial</Link></li>
            <li><Link to="/map" className="hover:text-emerald-400">Map View</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-3">Popular Locations</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/hyderabad" className="hover:text-emerald-400">Near Hyderabad</Link></li>
            <li><Link to="/kadthal" className="hover:text-emerald-400">Kadthal</Link></li>
            <li><Link to="/shadnagar" className="hover:text-emerald-400">Shadnagar</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-[#C8A24C] font-semibold mb-3">Company</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-[#C8A24C]">About Us</Link></li>
            <li><Link to="/guides" className="hover:text-[#C8A24C]">Guides & Resources</Link></li>
            <li><Link to="/contact" className="hover:text-[#C8A24C]">Contact Us</Link></li>
            <li><Link to="/privacy" className="hover:text-[#C8A24C]">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-[#C8A24C]">Terms & Conditions</Link></li>
            <li><Link to="/listing-policy" className="hover:text-[#C8A24C]">Listing Policy</Link></li>
            <li><Link to="/disclaimer" className="hover:text-[#C8A24C]">Disclaimer</Link></li>
            <li><Link to="/premium" className="hover:text-[#C8A24C]">Premium Plans</Link></li>
            <li><Link to="/list-property" className="hover:text-[#C8A24C]">Post Property</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-[#C8A24C] font-semibold mb-3">Get in touch</h4>
          <p className="text-sm text-slate-400 mb-3">Have a property or a query? We'd love to help.</p>
          <Link to="/contact" data-testid="footer-contact-cta" className="inline-flex items-center gap-2 bg-[#C8A24C] text-[#0E3B2E] font-semibold text-sm px-4 py-2 rounded-full hover:bg-[#A8863A]">Contact Us</Link>
        </div>
      </div>
      <div className="border-t border-slate-800 py-5 text-center text-xs text-slate-500">© {new Date().getFullYear()} Dotlands Realty. All rights reserved.</div>
    </footer>
  );
}
